import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { trigger, transition, style, animate } from '@angular/animations';
import { ErrorService, ErrorMessage } from '../../services/error.service';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.css'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('300ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class ErrorModalComponent implements OnInit, OnDestroy {
  errors: ErrorMessage[] = [];
  private destroy$ = new Subject<void>();

  constructor(private errorService: ErrorService) { }

  ngOnInit(): void {
    this.errorService.errors$
      .pipe(takeUntil(this.destroy$))
      .subscribe(errors => {
        this.errors = errors;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  closeError(errorId: string): void {
    this.errorService.removeError(errorId);
  }

  getErrorIcon(type: string): string {
    switch (type) {
      case 'error':
        return '⊗';
      case 'warning':
        return '⚠';
      case 'info':
        return 'ℹ';
      case 'success':
        return '✓';
      default:
        return '⊗';
    }
  }

  getModalClass(type: string): string {
    switch (type) {
      case 'error':
        return 'modal-content error';
      case 'warning':
        return 'modal-content warning';
      case 'info':
        return 'modal-content info';
      case 'success':
        return 'modal-content success';
      default:
        return 'modal-content error';
    }
  }

  getErrorTitle(type: string): string {
    switch (type) {
      case 'error':
        return 'Erro';
      case 'warning':
        return 'Aviso';
      case 'info':
        return 'Informação';
      case 'success':
        return 'Sucesso';
      default:
        return 'Erro';
    }
  }

  trackByErrorId(index: number, error: ErrorMessage): string {
    return error.id;
  }
}
